const usernameRegex = /^[a-zA-Z0-9_]+$/;

export const validateUsername = (username) => {
    return usernameRegex.test(username);
};

export const getUsernameValidationMessage = (username) => {
    if (!username || username.length === 0) {
        return "Username is required.";
    }

    if (username.length < 3) {
        return "Username must be at least 3 characters long.";
    }

    if (username.length > 30) {
        return "Username must be no more than 30 characters long.";
    }

    if (!validateUsername(username)) {
        return "Username can only contain letters, numbers, and underscores (no spaces or special characters).";
    }

    return null;
};
